import { Text } from "@chakra-ui/react";
import { FC } from "react";

import {
  Table,
  TableDataColumn,
  TableDataRow,
  TableHeaderColumn,
  TableHeaderRow,
} from "~/src/components/common/tables/Table";

import {
  matchTypeLabels,
  truncateText,
} from "../UrlMappingForm/urlMappingFormUtils";

import {
  ParsedUrlMappingImportRow,
  formatImportRowSourceSummary,
} from "./urlMappingCsvUtils";

export type Props = {
  parsedRows: ParsedUrlMappingImportRow[];
};

export const UrlMappingCsvImportPreview: FC<Props> = ({ parsedRows }) => (
  <Table>
    <TableHeaderRow>
      <TableHeaderColumn>行</TableHeaderColumn>
      <TableHeaderColumn>名称</TableHeaderColumn>
      <TableHeaderColumn>マッチ種別</TableHeaderColumn>
      <TableHeaderColumn>優先度</TableHeaderColumn>
      <TableHeaderColumn>ソース</TableHeaderColumn>
      <TableHeaderColumn>宛先</TableHeaderColumn>
      <TableHeaderColumn>状態</TableHeaderColumn>
    </TableHeaderRow>
    {parsedRows.map(({ lineNum, row, errors }) => {
      const isValid = errors.length === 0;
      const displayName = row.name || "(名称なし)";

      return (
        <TableDataRow key={lineNum}>
          <TableDataColumn type="text" data={String(lineNum)} />
          <TableDataColumn type="text" data={displayName} />
          <TableDataColumn
            type="text"
            data={
              matchTypeLabels[row.matchType as keyof typeof matchTypeLabels] ??
              row.matchType
            }
          />
          <TableDataColumn type="text" data={String(row.priority ?? 100)} />
          <TableDataColumn
            type="text"
            data={truncateText(formatImportRowSourceSummary(row))}
          />
          <TableDataColumn
            type="text"
            data={truncateText(row.destinationUrl)}
          />
          <TableDataColumn
            type="text"
            data={
              isValid ? (
                <Text color="#38A169" fontSize="11px">
                  OK
                </Text>
              ) : (
                <Text color="#E53E3E" fontSize="11px" whiteSpace="pre-wrap">
                  {errors.join("\n")}
                </Text>
              )
            }
          />
        </TableDataRow>
      );
    })}
  </Table>
);
